/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('chapter', function () {
        return {
            scope: {
                chapterIndex: '@',
                chapterStyle: '='
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/chapter/chapter.view.html',
            controller: ["$scope", "DocumentModel", "DocumentService", "Styles", "$sce", "$timeout", function ($scope, DocumentModel, DocumentService, Styles, $sce, $timeout) {
                var callbackId, chapterContent;
                var elementReference = angular.element('div.' + $scope.chapterStyle);
                var scope = $scope;
                var chapterIndex = parseInt(scope.chapterIndex);

                $scope.processChapterContent = function(){
                    // debugger
                    var baseUrl = DocumentModel.getDocumentBaseInformation().baseUrl + DocumentModel.getChapterBaseUrl(chapterIndex);
                    var styleTag, chapterContent;
                    var documentFormat = DocumentModel.getDocumentFormat();


                    callbackId && DocumentModel.unsubscribe.onChapterLoaded(chapterIndex, callbackId);
                    chapterContent = DocumentModel.getChapterContent(chapterIndex);

                    if(documentFormat === 'epub') {
                        styleTag = angular.element('link[type="text/css"]', chapterContent);
                        if (!!styleTag.length) {
                            Styles.appendStyleSheet(baseUrl + styleTag.attr('href'), $scope.chapterStyle, chapterIndex);
                        }

                        chapterContent = angular.element('body>*:eq(0)', chapterContent);
                        chapterContent.find('img').each(function (i, el) {
                            angular.element(el).attr('src', baseUrl + angular.element(el).attr('src'));
                        });

                        angular.element('svg image', chapterContent).each(function (i, el) {
                            var element = angular.element(el);
                            element.attr('xlink:href', baseUrl + element.attr('xlink:href'));
                        });

                        $scope.content = $sce.trustAsHtml(chapterContent.html());
                    } else if (documentFormat === 'pdf'){
                        $scope.content = $sce.trustAsHtml('<img src="' + chapterContent + '"/>');
                    }

                    //angular.element('[xmlns]').removeAttr('xmlns');

                    $timeout(function(){
                        var bookmarksCollection = {};


                        //collecting chapter bookmarks
                        angular.element('div.' + $scope.chapterStyle).find('*').each(function(i, el){
                            var bookmarkAttribute = el.getAttribute('p:p');

                            if(!bookmarkAttribute && documentFormat === 'pdf'){
                                bookmarkAttribute = angular.element(el).position().top;
                            }

                            if (!!bookmarkAttribute) {
                                bookmarksCollection[bookmarkAttribute] = {
                                    element: el,
                                    offsetPx: angular.element(el).position().top,
                                    url: DocumentModel.getChapterUrlById(chapterIndex)
                                };
                            }
                        });

                        var chapterBaseOffset = angular.element('div.' + $scope.chapterStyle).position().top;

                        //collecting cfi bookmarks
                        function collectBookmarks(parentNode) {
                            var bookmarks = [];

                            parentNode.children().each(function (i, el) {
                                bookmarks[i] = {
                                    element: el,
                                    offsetPx: angular.element(el).position().top - chapterBaseOffset,
                                    children: !!angular.element(el).children().length?collectBookmarks(angular.element(el)):null
                                };
                            });

                            return bookmarks;
                        };

                        var cfiBookmarks = collectBookmarks(angular.element('div.' + $scope.chapterStyle).children(':eq(0)'));
                        DocumentService.updateChapterBookmarks(chapterIndex, bookmarksCollection);
                        DocumentService.updateCfiBookmarks(chapterIndex,  cfiBookmarks);
                        DocumentService.setChapterRendered(chapterIndex);
                        console.log('$scope.chapterStyle',$scope.chapterStyle);
                        console.log('elemref',elementReference);
                        DocumentService.updateDocumentHeight(angular.element('div.' + $scope.chapterStyle).height());
                    }, 500);
                };

                console.log(elementReference, DocumentModel.checkIf.isChapterLoaded(chapterIndex));
                if (elementReference && DocumentModel.checkIf.isChapterLoaded(chapterIndex)) {
                    $scope.processChapterContent();
                } else {
                    callbackId = DocumentModel.subscribe.onChapterLoaded(chapterIndex,
                    function(){
                        $scope.processChapterContent();
                    });
                }
            }]
        };
    });